import * as comissao from '@/api/comissao'

const state = {
  list: [],
  filtros: {page: 1},
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalConfDelUnidade: false
}

const mutations = {
  SETCOMISSOES (state, payload) {
    state.list = payload
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  HIDDEMODAL (state) {
    state.modalAdd = false
    state.modalEdit = false
  },
  MODALADD (state) {
    state.modalAdd = !state.modalAdd
  },
  MODALEDIT (state) {
    state.modalEdit = !state.modalEdit
  }
}

const actions = {
  hiddeModal: function ({ commit }) {
    commit('HIDDEMODAL')
  },
  modalAdd: function ({ commit }) {
    commit('MODALADD')
  },
  modalEdit: function ({ commit }) {
    commit('MODALEDIT')
  },
  async getComissoes ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await comissao.getComissoes(payload)
    commit('SETCOMISSOES', data)
    commit('SETPAGINATE', data.pages)
  },
  async getComissoesFiltro ({ commit, dispatch }) {
    let data = await comissao.getComissoes(state.filtros)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETCOMISSOES', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async getComissoesByInstituicao ({ commit }, payload) {
    let filtro = {instituicao_id: payload, active: true}
    let data = await comissao.getComissoes(filtro)
    return data
  },
  async getComissoesLiberadoByInstituicao ({ commit }, payload) {
    if (payload.data) {
      let data = payload.data.split('/')
      payload.data = data[2] + '-' + data[1] + '-' + data[0]
    } else delete payload.data
    let data = await comissao.getComissoesLiberado(payload)
    return data
  },
  async get ({ commit }, payload) {
    let data = await comissao.get(payload)
    return data
  },
  async add ({ commit }, payload) {
    payload.produto.id = payload.produto.value
    payload.instituicao.id = payload.instituicao.value
    try {
      await comissao.add(payload)
      return true
    } catch (e) {
      throw new Error(e)
    }
  },
  async addArray ({ commit }, payload) {
    await comissao.addArray(payload)
    return true
  },
  async edit ({ commit }, payload) {
    if (payload.produto) {
      payload.produto.id = payload.produto.value
    }
    if (payload.instituicao) {
      payload.instituicao.id = payload.instituicao.value
    }
    try {
      await comissao.edit(payload)
      return true
    } catch (e) {
      throw new Error(e)
    }
  },
  async mudaStatus ({ commit }, payload) {
    try {
      await comissao.status(payload)
      return true
    } catch (e) {
      return e
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getComissoes', state.filtros)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/comissao.js